module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar"
  }, [_c('div', {
    staticClass: "container clearfix"
  }, [_c('div', {
    staticClass: "navbar-logo"
  }, [_c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/logo.png"
    }
  })])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.state.city.remarks),
      expression: "$store.state.city.remarks"
    }],
    staticClass: "navbar-phone stxihei"
  }, [_vm._v(_vm._s(_vm.$store.state.city.remarks))]), _vm._v(" "), _c('div', {
    staticClass: "navbar-city"
  }, [_c('span', {
    staticClass: "current-city"
  }, [_vm._v("\n        " + _vm._s(_vm.$store.state.city.name) + "\n        "), _c('i', [_vm._v("[切换城市]")])]), _vm._v(" "), _c('ul', {
    staticClass: "city-list"
  }, _vm._l((_vm.cityList), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "city-item",
      class: {
        'active': item.active
      },
      on: {
        "click": function($event) {
          _vm.onClick(index)
        }
      }
    }, [_vm._v(_vm._s(item.cityName))])
  }))]), _vm._v(" "), _c('ul', {
    staticClass: "navbar-navs"
  }, [_vm._l((_vm.menuArr), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "navbar-item",
      class: item.cls
    }, [(!item.children || item.children.length === 0) ? _c('router-link', {
      attrs: {
        "to": item.to,
        "exact": ""
      }
    }, [_vm._v("\n          " + _vm._s(item.text) + "\n        ")]) : _c('a', {
      attrs: {
        "href": "javascript:;"
      }
    }, [_vm._v("\n          " + _vm._s(item.text) + "\n          "), _c('span', {
      staticClass: "angle"
    }), _vm._v(" "), _c('ul', {
      staticClass: "navbar-subbar clearfix"
    }, _vm._l((item.children), function(subNav, index) {
      return _c('li', {
        key: index,
        staticClass: "navbar-subbar-item"
      }, [_c('router-link', {
        attrs: {
          "to": subNav.to,
          "exact": "",
          "target": subNav.target
        }
      }, [_vm._v(_vm._s(subNav.text))])], 1)
    }))])], 1)
  }), _vm._v(" "), _c('li', {
    staticClass: "navbar-item"
  }, [_c('a', {
    attrs: {
      "href": 'http://pms.91weijia.com/public-service/query_service.html?cityCode=' + _vm.cityCode + '&channel=0',
      "target": "_blank"
    }
  }, [_vm._v("查询服务")])])], 2), _vm._v(" "), _c('div', {
    staticClass: "navbar-userInfo"
  }, [(!_vm.$store.state.token) ? _c('div', {
    staticClass: "user-info noLogin"
  }, [_c('a', {
    staticClass: "active",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.toLogin
    }
  }, [_vm._v("登录")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/register"
    }
  }, [_vm._v("注册")])], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.token) ? _c('div', {
    staticClass: "user-info isLogin"
  }, [_c('router-link', {
    staticClass: "active",
    attrs: {
      "type": "span",
      "to": "/u/order"
    }
  }, [_vm._v(_vm._s(_vm.userPhone))]), _vm._v(" "), _c('a', {
    staticClass: "logout",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.toLogout
    }
  }, [_vm._v("【安全退出】")])], 1) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-3346ef08"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/navbar/navbar.vue
// module id = 593
// module chunks = 1